import { FORM_FIELDS } from "@constants/form";

const TENDER_EVOLUTION = FORM_FIELDS.PROCUREMENT_DETAILS.TENDER_EVOLUTION;

const { VENDOR_NAME, PROPOSED_PRICE, STATUS, SELECTED_VENDOR_FOR_NOA } =
  TENDER_EVOLUTION;

export const getTenderInfo = (vendorList: any[]) => {
  const responsiveVendors = vendorList.filter(
    (item) => item?.[STATUS]?.toLowerCase() === "responsive",
  );

  if (responsiveVendors.length > 0) {
    const minValue = responsiveVendors.sort(function (a, b) {
      return a?.[PROPOSED_PRICE] - b?.[PROPOSED_PRICE];
    })[0];

    return minValue;
  } else {
    return "No Responsive Vendor Selected";
  }
};
